import $ from "cash-dom";
import {calculateApi} from "../api/calculate";
import anime from "animejs";

const suffixYears = years => {
    switch (years) {
        case 1:
            return 'rok';

        case 2:
        case 3:
        case 4:
            return 'roky';

        default:
            return 'rokov';
    }
};

export const stepsComponent = (root) => {
    const $root = $(root);

    const stepsPreviousYear = $root.find('.steps-arrow-left').get(0);
    const stepsNextYear = $root.find('.steps-arrow-right').get(0);
    const stepsYearSelectScroll = $root.find('.steps-year-select-scroll').get(0);
    const stepsYearSelectScrollMobile = $root.find('.steps-year-select-scroll-mobile').get(0);
    const stepsYearSelect = $root.find('.steps-year-select').get(0);
    const stepsContainer = $root.find('.steps-container').get(0);
    const stepsOverlay = $root.find('.steps-overlay').get(0);
    const stepsShow = $root.find('.steps-show').get(0);
    const stepsContent = $root.find('.steps-content').get(0);
    const dataTexts = {
        'loan_amount': $root.find('.loan_amount').get(0),
        'loan_duration': $root.find('.loan_duration').get(0),
        'rate': $root.find('.rate').get(0),
    };

    let data, results, result, activeYear;

    const renderPayments = async () => {
        const contentDesktop = await calculateApi.stepsView('desktop', {data, results, year: activeYear});
        stepsContent.innerHTML = contentDesktop;
    };

    const updateScroll = (animate = true) => {
        const containerWidth = stepsYearSelectScroll.clientWidth;
        const contentWidth = stepsYearSelect.clientWidth;
        const itemWidth = 52 + 2 * 6;

        if (contentWidth <= containerWidth) {
            stepsYearSelectScroll.scroll({left: 0});
        } else {
            const itemOffset = itemWidth * activeYear;
            const centerOffset = containerWidth / 2.0;
            const itemCenterOffset = itemWidth / 2.0;

            anime({
                targets: stepsYearSelectScroll,
                scrollLeft: itemOffset - centerOffset + itemCenterOffset,
                duration: animate ? 150 : 0,
                easing: 'easeInOutSine',
            });
        }
    };

    const setActiveYear = newActiveYear => {
        $(stepsYearSelect).find(`*[data-value="${activeYear}"]`)
            .toggleClass('border bg-gradient-contact text-white');
        activeYear = newActiveYear;
        $(stepsYearSelect).find(`*[data-value="${activeYear}"]`)
            .toggleClass('border bg-gradient-contact text-white');

        stepsYearSelectScrollMobile.innerText = activeYear + 1;

        updateScroll();
        renderPayments();
    };

    const renderYearSelect = () => {
        const content = [];
        for (let year = 0; year < data.loan_duration; ++year)
            content.push(`<div class="rounded-full animate w-13 h-13 flex items-center justify-center border border-blue-dark mx-1.5 cursor-pointer" data-value="${year}">${year + 1}</div>`);
        stepsYearSelect.innerHTML = content.join('\n');

        $(stepsYearSelect).find(`*[data-value="${activeYear}"]`)
            .toggleClass('border bg-gradient-contact text-white');

        $(stepsYearSelect).children().on('click', e => {
            setActiveYear(parseInt(e.target.getAttribute('data-value')));
        });

        stepsYearSelectScrollMobile.innerText = activeYear + 1;

        updateScroll(false);
    };

    const updateSteps = (newData, newResults) => {
        data = newData;
        results = newResults;
        activeYear = 0;

        let partner = null;
        for (const result of results) {
            if (!partner || partner.rate > result.rate)
                partner = result;
        }
        result = partner;

        dataTexts.loan_amount.innerHTML = `${data.loan_amount} &euro;`;
        dataTexts.rate.innerHTML = `${result.rate} %`;
        dataTexts.loan_duration.innerHTML = `${data.loan_duration} ${suffixYears(data.loan_duration)}.`;

        renderYearSelect();
        return renderPayments();
    };

    stepsShow.onclick = () => {
        stepsContainer.style.maxHeight = '9999px';
        stepsOverlay.style.opacity = '0';
        stepsShow.style.pointerEvents = 'none';
    };

    stepsPreviousYear.onclick = () => {
        if (activeYear > 0)
            setActiveYear(activeYear - 1);
    };

    stepsNextYear.onclick = () => {
        if (activeYear < data.loan_duration - 1)
            setActiveYear(activeYear + 1);
    };

    return {
        updateSteps,
    };
};
